import { render, staticRenderFns } from "./period-sales-per-group.card.vue?vue&type=template&id=08a1cb2e&scoped=true&"
import script from "./period-sales-per-group.card.vue?vue&type=script&lang=js&"
export * from "./period-sales-per-group.card.vue?vue&type=script&lang=js&"
import style0 from "./period-sales-per-group.card.vue?vue&type=style&index=0&id=08a1cb2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1cb2e",
  null
  
)

export default component.exports